export default __webpack_public_path__ + "static/media/logo-legalzoom.e22be231.png";